export default __webpack_public_path__ + "media/zurb/img/work/paysa-thumb2-94da2f09e0c7ffeeb76347a88906c8b1.png";